// Preset target lead times offered in the step menu, in days.
export const RECRUITMENT_FLOW_PRESET_DAY_OPTIONS = [1, 3, 5, 7, 10, 14, 21, 30];

export const RECRUITMENT_FLOW_STEP_ICON = {
    LEAD_TIME: 'clock-stopwatch',
    DEADLINE: 'calendar',
};

// Menu class names the acceptance suite selects on.
export const RECRUITMENT_FLOW_MENU_CLASS = {
    LEAD_TIME: 'recruitment-flow-leadtime-menu',
    DEADLINE: 'recruitment-flow-deadline-menu',
};

export const RECRUITMENT_FLOW_VARIANT = {
    // The company flow editor in settings.
    SETTINGS: 'settings',
    // The job's own plan editor, which adds the deadline.
    POSITION: 'position',
};
